import { apiRequest } from "@/services/api-client";
import {
  GetEvolutionOptionsInput,
  GetEvolutionOptionsOutput,
  EvolvePokemonInput,
  EvolvePokemonOutput,
  WebAppRoutes,
} from "types/web-app";

/**
 * Get available evolution options for a Pokemon
 */
export const getEvolutionOptions = (input: GetEvolutionOptionsInput) =>
  apiRequest<GetEvolutionOptionsOutput>(
    "/" + WebAppRoutes.GET_EVOLUTION_OPTIONS,
    {
      method: "POST",
      body: JSON.stringify(input),
    },
  );

/**
 * Evolve a Pokemon to a target species
 */
export const evolvePokemon = (input: EvolvePokemonInput) =>
  apiRequest<EvolvePokemonOutput>("/" + WebAppRoutes.EVOLVE_POKEMON, {
    method: "POST",
    body: JSON.stringify(input),
  });
